import { useMemo, useRef } from "react";

import { isRedirectReturn, resolveFunnelUuid } from "./useFunnelUuid";

// PAY-404 -- `CheckoutSessionProvider` does NOT unmount/remount when a
// member navigates client-side to a different checkout page (same TanStack
// Router route definition, re-rendered with new props). `paywallId` is the
// stable, synchronous signal that the *checkout run* changed (unlike
// `session?.id`, which resolves asynchronously and would spuriously look
// "changed" mid-mount) -- when it changes, the funnel UUID and double-fire
// guard must reset, or the new checkout gets deduped against the previous
// one's already-fired entries.
//
// Funnel cookie creation waits for a session, independently of provider flags.
export const useConversionTrackingFunnelState = (
  paywallId: number,
  isSessionReady: boolean,
) => {
  const conversionTrackingFiredRef = useRef<string | null>(null);
  const funnelUuidRef = useRef<string | null>(null);

  const previousPaywallIdRef = useRef<number | null>(null);
  const isNewCheckoutRun =
    previousPaywallIdRef.current !== null &&
    previousPaywallIdRef.current !== paywallId;
  if (isNewCheckoutRun) {
    conversionTrackingFiredRef.current = null;
    funnelUuidRef.current = null;
  }
  previousPaywallIdRef.current = paywallId;

  const search = globalThis.location?.search ?? "";
  const isRedirectReturnMount = useMemo(
    () => isRedirectReturn(search),
    [search],
  );
  if (isSessionReady && funnelUuidRef.current === null) {
    funnelUuidRef.current = resolveFunnelUuid(search);
  }
  const funnelUuid = funnelUuidRef.current ?? "";

  return { conversionTrackingFiredRef, funnelUuid, isRedirectReturnMount };
};
